import { render, staticRenderFns } from "./admin-inmuebles.vue?vue&type=template&id=12726632&"
import script from "./admin-inmuebles.vue?vue&type=script&lang=js&"
export * from "./admin-inmuebles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports